<script>
export default {
  name: 'ResellerAgentListItem',
  props: {
    user: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onDelete() {
      this.$emit('delete', this.user);
    },
  },
};
</script>

<template>
  <tr>
    <td>
      <router-link :to="`/resellerAgent/${user.id}`">{{ user.username }}</router-link>
    </td>
    <td>{{ user.email }}</td>
    <td>{{ user.firstname }}</td>
    <td>{{ user.surname }}</td>
    <td width="80" align="right">
      <v-tooltip bottom>
        <v-btn @click.native="onDelete"
               flat icon small
               slot="activator"
               :disabled="user.isDelete">
          <v-icon small color="red lighten-2">delete</v-icon>
        </v-btn>
        <span>Löschen</span>
      </v-tooltip>
    </td>
  </tr>
</template>
